module.exports = __webpack_public_path__ + "static/media/preview.d8cd645f.png";